import PropTypes from 'prop-types';
import React from 'react';
import {
    defineMessages, 
    injectIntl, 
    // intlShape, 
    FormattedMessage
} from 'react-intl';
import './drawer.css';
import bindAll from 'lodash.bindall';
import disAdd from './assets/disAdd.png';
import disDelete from './assets/disDelete.png';
import addIcon from './assets/addIcon.png';
import deleteIcon from './assets/deleteIcon.png';
import { Input } from 'antd';
import { connect } from 'react-redux';
// import VM from 'scratch-vm';
import CustomModal from '../containers/custom-modal.jsx';
import modalBack from './assets/modalWifi.png'

const messages = defineMessages({
    deviceHasTitle: {
        defaultMessage: 'Connected device',
        description: 'Connected device',
        id: 'gui.homePage.deviceHasTitle'
    },
    deviceName: {
        defaultMessage: 'Device',
        description: 'Device',
        id: 'gui.homePage.deviceName'
    },
    deviceNumber: {
        defaultMessage: 'Serial Number',
        description: 'Serial Number',
        id: 'gui.homePage.deviceNumber'
    },
    deviceContent: {
        defaultMessage: 'Please connect to the Nous master',
        description: 'Please connect to the Nous master',
        id: 'gui.homePage.deviceContent'
    },
    deviceNoContent: {
        defaultMessage: 'Device not connected',
        description: 'Device not connected',
        id: 'gui.homePage.deviceNoContent'
    },
    deviceCams: {
        defaultMessage: 'Camera',
        description: 'Camera',
        id: 'gui.homePage.deviceCams'
    },
    deviceSave: {
        defaultMessage: 'Save',
        description: 'Save',
        id: 'gui.homePage.deviceSave'
    },
    deviceUpdateID: {
        defaultMessage: 'Modify ID',
        description: 'Modify ID',
        id: 'gui.homePage.deviceUpdateID'
    },
    servoTitle: {
        defaultMessage: 'Servo',
        description: 'servo',
        id: 'gui.homePage.servoTitle'
    },
    deviceUpdateIDBtn: {
        id: 'gui.homePage.deviceUpdateIDBtn',
        defaultMessage: 'Confirm',
        description: 'Confirm'
    },
    deviceUpdateIDTips: {
        id: 'gui.homePage.deviceUpdateIDTips',
        defaultMessage: 'Please ensure that the connected sensor IDs are inconsistent',
        description: 'Please ensure that the connected sensor IDs are inconsistent'
    },
    burnFailedModeTitle: {
        id: 'gui.homePage.burnFailedModeTitle',
        defaultMessage: 'Tips',
        description: 'Tips'
    }
});

class DeviceComponent extends React.Component {
    constructor (props) {
        super(props);
        // eslint-disable-next-line max-len
        bindAll(this, [
            'updateIdClick',
            'saveIdClick',
            'cancelIdClick',
            'deleteNumber',
            'addNumber',
            'updateNumber',
            'isPositiveIntegerInRange',
            'getOkClick'
        ]);
        this.state = {
            deviceList: [],
            deviceListUpdate: [],
            // activeIndex: 0,
            updateState: false,
            deviceTipsStatus: false
        };
        // this.componentReady = React.createRef();
    }

    componentDidMount () {
        // this.componentReady.current = true;
        // this.updateServoData()
    }

    shouldComponentUpdate (nextProps, nextState) {
        // console.log(JSON.stringify(nextProps.deviceListAll) !== JSON.stringify(this.state.deviceList) ||
        // nextState.updateState !== this.state.updateState)
        return  JSON.stringify(nextProps.deviceListAll) !== JSON.stringify(this.state.deviceList) ||
                nextState.updateState !== this.state.updateState
    }

    componentDidUpdate (prevProps, prevState) {
        this.setState({
            deviceList: [...prevProps.deviceListAll]
        });
    }

    componentWillUnmount () {
        // this.props.segments.forEach(segment => {
        //     segment.ref.current.remove();
        // });
        // this.componentReady = null;
    }

    // 修改id
    updateIdClick () {
        this.setState({
            updateState: true,
            deviceListUpdate: [ ...this.state.deviceList]
        });
    }

    // 保存信息
    saveIdClick () {
        this.setState({
            updateState: false
        });
        if (window.peripheral) {
            const promise = window.peripheral.servoIdChange(this.state.deviceListUpdate);
        }
    }

    // 取消修改
    cancelIdClick () {
        this.setState({
            updateState: false
        });
        this.forceUpdate();
    }

    // 减少id序号
    deleteNumber(index, id) {
        let data = [...this.state.deviceList];
        data[index] = {
          ...data[index],
          newId: this.state.deviceListUpdate[index].newId - 1
        };
        this.setState({
          deviceListUpdate: data
        });
        this.forceUpdate();
    }

    // 增加id序号
    addNumber (index, id) {
        let data = [...this.state.deviceList];
        data[index] = {
          ...data[index],
          newId: this.state.deviceListUpdate[index].newId + 1
        };
        this.setState({
          deviceListUpdate: data
        });
        this.forceUpdate();
    }

    isPositiveIntegerInRange (num) {
        const parsed = parseInt(num, 10);
        if (isNaN(parsed)) {
            // 如果输入的不是数字，返回 false
            return false;
        }
        return parsed > 0 && parsed < 30 && Number.isInteger(parsed);
    }

    // 修改input updateNumber
    updateNumber (e) {
        // console.log(e);
        // this.forceUpdate();
        // if (!this.isPositiveIntegerInRange(id)) {
        //     message.error('请填入一个大于0小于30的正整数')
        //     return false
        // }
        // const data = [...this.state.deviceList]
        // data[index].id = id;
        // this.setState({ deviceList: data });
        // this.forceUpdate();
    }

    // 知晓
    getOkClick () {
        this.setState({
            deviceTipsStatus: false
        });
    }

    render () {
        const {deviceState, intl} = this.props;
        const {updateState, deviceList, deviceTipsStatus, deviceListUpdate} = this.state;
        // console.log(this.props.list, deviceList);
        return (
            <div
                className="deviceContainer"
                ref={this.props.controlRef}
            >
                <div className="deviceContent">
                    {deviceList.length > 0 && !updateState && <div className="deviceTitle">{intl.formatMessage(messages.deviceHasTitle)}</div>}
                    {/* 修改id */}
                    {deviceList.length > 0 && updateState && (
                        <div className="deviceTitleUpdate">
                            <div style={{position: 'absolute', left: '34px'}}>{intl.formatMessage(messages.deviceName)}</div>
                            <div style={{position: 'absolute', right: '3px', textAlign: 'center', width: '100px'}}>{intl.formatMessage(messages.deviceNumber)}</div>
                        </div>
                    )}
                    {deviceList.length === 0 && deviceState && <div className="noDevice">{intl.formatMessage(messages.deviceContent)}</div>}
                    {deviceList.length === 0 && !deviceState && <div className="noDevice">{intl.formatMessage(messages.deviceNoContent)}</div>}
                    {deviceList.length > 0 && (
                        <div className="deviceContents">
                            {/* {intl.formatMessage(messages.deviceCams)} */}
                            {updateState ? (
                                <div>
                                    {deviceListUpdate.map((i, index) => (
                                        <div
                                            key={index}
                                            className="deviceId"
                                        >
                                            <div className="devideName">
                                                {intl.formatMessage(messages.servoTitle)}
                                                <div className="deviceNumberId">{i.id}</div>
                                            </div>
                                            <div className="deviceNumber">
                                                {i.newId === 0 && <img src={disDelete} />}
                                                {i.newId !== 0 && <img
                                                    src={deleteIcon}
                                                    onClick={() => this.deleteNumber(index, i.newId)}
                                                />}
                                                <Input
                                                    value={i.newId}
                                                    onChange={() => this.updateNumber}
                                                />
                                                {i.newId === 30 && <img src={disAdd} />}
                                                {i.newId !== 30 && <img
                                                    src={addIcon}
                                                    onClick={() => this.addNumber(index, i.newId)}
                                                />}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div>
                                    {deviceList.map((i, index) => (
                                        <div
                                            key={index}
                                            className="deviceId"
                                        >
                                            <div className="devideName">
                                                {intl.formatMessage(messages.servoTitle)}
                                                <div className="deviceNumberId">{i.id}</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}
                </div>
                {/* 设备未接入 */}
                {deviceList.length === 0 && !deviceState && (
                    <div className="footerDevice">
                        <div className="okBtnDisDevice">{intl.formatMessage(messages.deviceSave)}</div>
                        <div className="cancelBtnDis">
                            <FormattedMessage
                                defaultMessage="Cancel"
                                id="gui.homePage.cancel"
                            />
                        </div>
                    </div>
                )}
                {/* 设备接入 */}
                {deviceList.length > 0 && !deviceState && !updateState && (
                    <div className="footerDevice">
                        <div
                            className="updateBtn"
                            onClick={this.updateIdClick}
                        >
                            {intl.formatMessage(messages.deviceUpdateID)}
                        </div>
                    </div>
                )}
                {/* 修改设备id保存 */}
                {deviceList.length > 0 && !deviceState && updateState && (
                    <div className="footerDevice">
                        <div
                            className="okBtnDevice"
                            onClick={this.saveIdClick}
                        >
                            {intl.formatMessage(messages.deviceSave)}
                        </div>
                        <div
                            className="cancelBtnDevice"
                            onClick={this.cancelIdClick}
                        >
                            <FormattedMessage
                                defaultMessage="Cancel"
                                id="gui.homePage.cancel"
                            />
                        </div>
                    </div>
                )}
                {/* 请确保已接入传感器ID不一致 重复时提示 */}
                {deviceTipsStatus && !deviceState && (
                    <CustomModal
                        className="modalContent"
                        id="deviceIdModal"
                        contentLabel={this.props.intl.formatMessage(messages.burnFailedModeTitle)}
                        hasHeaderLine={false}
                        headerImageTop={modalBack}
                        onRequestClose={() => {
                            this.setState({
                                deviceTipsStatus: false
                            });
                        }}
                    >
                        <div className="content">{this.props.intl.formatMessage(messages.deviceUpdateIDTips)}</div>
                        {/* 知晓按钮 */}
                        <div
                            className="okBtn"
                            onClick={this.getOkClick}
                        >
                            {/* 保存 */}
                            {intl.formatMessage(messages.deviceUpdateIDBtn)}
                        </div>
                    </CustomModal>
                )}
            </div>
        );
    }
}

DeviceComponent.defaultProps = {
    callback: () => {},
    controlRef: React.createRef(),
    segments: []
};

DeviceComponent.propTypes = {
    // vm: PropTypes.instanceOf(VM).isRequired,
    // intl: intlShape.isRequired,
    deviceListAll: PropTypes.arrayOf(
        PropTypes.shape({
            newId: PropTypes.number,
            id: PropTypes.number
        })
    ),
    name: PropTypes.string,
    list: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            id: PropTypes.number
        })
    ),
    deviceState: PropTypes.bool,
    callback: PropTypes.func,
    defaultIndex: PropTypes.number,
    isConnected: PropTypes.bool,
    controlRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({current: PropTypes.instanceOf(Element)})])
};

const mapStateToProps = state => ({
    isConnected: state.connectStore.isConnected,
    deviceListAll: state.connectStore.deviceList
    // vm: state.scratchGui.vm
});
const mapDispatchToProps = dispatch => ({
});
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(DeviceComponent));
